import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import BreakoutAlerts from '../../pages/breakout-alerts';

const BreakoutAlertsWidget = (props) => {
  const queryClient = new QueryClient;
  const [darkMode, setDarkMode] = useState(false);
  const [lightMode, setLightMode] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const dm = urlParams.get('dm');
    const disabledm = urlParams.get('disabledm');

    if (dm == 1) {
      setDarkMode(true);
      setLightMode(false);
    } else if (disabledm == 1) {
      setLightMode(true);
      setDarkMode(false);
    } else {
      setDarkMode(false);
      setLightMode(false);
    }

    if (disabledm === "1") {
      const body = document.getElementsByTagName('body')[0];
      body.style.backgroundColor = "#FFFFFF";
    } else if (dm === "1" || (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
      const body = document.getElementsByTagName('body')[0];
      body.style.backgroundColor = "#2B2B2B";
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <BreakoutAlerts widget={true} darkMode={darkMode} lightMode={lightMode} widgetRows={4} {...props}/>
    </QueryClientProvider>
  );
};

export { BreakoutAlertsWidget };
